import React from 'react';

// Loading dialog shown while an AI step runs (FR-013, FR-014). The progress index is owned by
// DealIntakeApp so it keeps going from classification into extraction and restarts on each open.
export default function AnalysingDialog({open, title, sentences, index}) {
    if (!open) {
        return null;
    }
    const sentence = sentences[Math.min(index, sentences.length - 1)];

    return (
        <div className="di-dialog-backdrop" role="presentation">
            <div className="di-dialog" role="dialog" aria-modal="true" aria-labelledby="di-dialog-title">
                <h3 id="di-dialog-title" className="di-dialog__title">{title}</h3>
                <div className="di-dialog__spinner"><i className="fa fa-spinner fa-spin" aria-hidden="true"/></div>
                <p className="di-dialog__sentence" aria-live="polite">{sentence}</p>
            </div>
        </div>
    );
}
